<template lang="pug">
.contiene-alertas-del-dia(v-if="alertas.length > 0")
	div.alerta-del-dia(
		v-for="alerta in alertas"
		:key="alerta.id"
	)
		.icono.blink_me
			span(:class="alerta.Icono")
		div.contenido-alerta
			span.titulo-alerta {{ alerta.Titulo }}
			span.descripcion-alerta {{ alerta.Descripcion }}
</template>

<script>
export default {
	data () {
		return {
			alertas: []
		}
	},
	created () {
		this.getAlertas()
	},
	methods: {
		getAlertas () {
			const inicio = new Date()
			inicio.setHours(0)
			inicio.setMinutes(0)
			inicio.setSeconds(0)
			inicio.setDate(inicio.getDate() + 1)
			const fin = new Date()
			fin.setHours(23)
			fin.setMinutes(59)
			inicio.setSeconds(59)
			const form = {
				fecha_inicio: inicio,
				fecha_fin: fin
			}
			console.log(form.fecha_inicio)
			console.log(form.fecha_fin)
			this.$http.post('muro/php/ddd/Infrastructure/GetAlertasController.php', form)
				.then((res) => {
					this.alertas = res.data
				})
				.catch((e) => {
					console.error(e)
				})
		}
	}
}
</script>

<style scoped>
.contiene-alertas-del-dia {
	display: block;
	position: relative;
	margin: 5px;
	margin-bottom: 3rem;
	background-color: rgb(217, 229, 249);
	color: darkred;
	font-size: 1.3rem;
	border-radius: 3px 3px 0 0;
	border: 1px solid #3D4553;
	border-top: 3px solid #3D4553;
	box-shadow: 0 1rem 1.5rem rgba(0,0,0,0.4);
}
.alerta-del-dia {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 10px;
}

.alerta-del-dia:first-of-type {
	border-radius: 10px 10px 0 0;
}
.alerta-del-dia:nth-of-type(even) {
	background-color: white;
}

.alerta-del-dia .icono {
	flex-basis: 40px;
	flex-shrink: 0;
	flex-grow: 0;
	font-size: 2rem;
	padding: 10px;
	justify-content: center;
	align-items: center;
	align-content: center;
	text-align: center;
}

.blink_me {
	animation: blinker 1s linear infinite;
}

@keyframes blinker {
	50% {
		opacity: 0.1;
	}
}

.alerta-del-dia .contenido-alerta {
	display: flex;
	flex-direction: column;
}

.titulo-alerta {
	font-weight: bold;
	font-size: 1.3rem;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/alertas/alertas-del-dia.vue